module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074b4_banner_800x600.88a7db25.png";